
import { UpdateLogEntry } from '@/api/dtos/LogEntry.schema'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class UpdateLogEntryContent extends Vue {
  @Prop()
  logEntry!: UpdateLogEntry
}
